<template>
  <div class="home">
    <Header></Header>
    <div class="section" id="about-me" style="padding-bottom: 10px;" data-aos="zoom-in-up">
      <div class="container has-text-centered" style="max-width: 750px;">
        <h1 class="title medium is-2" style="margin-bottom: 10px;">{{ $t('aboutMe.title') }}</h1>
        <p class="regular" style="font-size: 1.4rem">{{ $t('aboutMe.description') }}</p>
      </div>
    </div>
    <div class="section p2" id="portfolio" data-aos="zoom-in-up">
      <div class="container has-text-centered">
        <h2 class="title is-2 medium mb-2" style="margin-bottom: 0;">{{ $t('portfolio.title') }}</h2>
        <h3 class="title is-3 medium" style="margin-bottom: 0;">{{ $t('portfolio.websites') }}</h3>
        <div class="columns mt-3 is-centered">
<!--          <div class="column is-4 pcol">-->
<!--            <div class="project-card">-->
<!--              <img src="images/projects/websites/imgstoday.png" style="border-radius: 24px 24px 0 0;">-->
<!--              <div class="project-card-text">-->
<!--                <h1 class="title is-4 has-text-left">imgs.today</h1>-->
<!--                <h1 class="subtitle is-5 has-text-left">{{ $t('portfolio.imgsToday.description') }}</h1>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="column is-4 pcol">
            <div class="project-card" data-aos="flip-up" @click="open('https://discordbots.pl')">
              <img src="images/projects/websites/discordbots.png" style="border-radius: 24px 24px 0 0;">
              <div class="project-card-text">
                <h1 class="title is-4 has-text-left">DiscordBots.pl</h1>
                <h1 class="subtitle is-5 has-text-left">{{ $t('portfolio.discordBots.description') }}</h1>
              </div>
            </div>
          </div>
          <div class="column is-4 pcol">
            <div class="project-card" data-aos="flip-up" @click="open('https://kaczkoland.pl')">
              <img src="images/projects/websites/kaczkoland.jpg" style="border-radius: 24px 24px 0 0;">
              <div class="project-card-text">
                <h1 class="title is-4 has-text-left">Kaczkoland.pl</h1>
                <h1 class="subtitle is-5 has-text-left">{{ $t('portfolio.kaczkoland.description') }}</h1>
              </div>
            </div>
          </div>
        </div>
        <h3 class="title is-3 medium" style="margin-bottom: 0;">{{ $t('portfolio.own') }}</h3>
        <div class="columns mt-3 is-centered">
          <div class="column is-4 pcol">
            <div class="project-card" data-aos="flip-up">
              <img src="images/projects/own/kaczkolandshorts.png" style="border-radius: 24px 24px 0 0;">
              <div class="project-card-text">
                <h3 class="title is-4 has-text-left">Kaczkoland Shorts</h3>
                <h4 class="subtitle is-5 has-text-left">{{ $t('portfolio.kaczkolandShorts.description') }}</h4>
              </div>
            </div>
          </div>
          <div class="column is-4 pcol">
            <div class="project-card" data-aos="flip-up" @click="open('https://kaczkoland.pl')">
              <img src="images/projects/own/kaczkoland.png" style="border-radius: 24px 24px 0 0;">
              <div class="project-card-text">
                <h3 class="title is-4 has-text-left">Kaczkoland.pl</h3>
                <h4 class="subtitle is-5 has-text-left">{{ $t('portfolio.kaczkoland.description') }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
    <div class="wave-container" style="margin-bottom: -1px;">
      <div class="container" style="padding-top: 20px">
        <h2 class="title is-3 medium has-text-centered" style="color: white">{{ $t('socialMedia.title') }}</h2>
<!--        <h1 class="subtitle light has-text-centered" style="color: white">Narazie tylko Youtube bo reszta posysa</h1>-->
        <div class="columns is-multiline is-centered is-vcentered is-centered">
<!--          <div class="column is-4 has-text-centered">-->
<!--            <blockquote class="twitter-tweet tw-align-center" data-lang="pl" data-theme="dark"><p lang="pl" dir="ltr">dzieki <a href="https://twitter.com/tiktok_us?ref_src=twsrc%5Etfw">@tiktok_us</a> za shadow bana <a href="https://t.co/DtSc2hxlBL">pic.twitter.com/DtSc2hxlBL</a></p>&mdash; rkubapl (@rkubapl) <a href="https://twitter.com/rkubapl/status/1477744448041848832?ref_src=twsrc%5Etfw">2 stycznia 2022</a></blockquote>-->
<!--          </div>-->
<!--          <div class="column is-4" style="display: flex; justify-content: center;">-->
<!--            <blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="https://www.instagram.com/p/CYHk0NEISu7/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/p/CYHk0NEISu7/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">Wyświetl ten post na Instagramie</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="https://www.instagram.com/p/CYHk0NEISu7/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">Post udostępniony przez Kaczkoland (@kaczkoland)</a></p></div></blockquote>-->
<!--          </div>-->
<!--          <div class="column is-4" style="display: flex; justify-content: center;">-->
<!--            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fkaczkoland%2Fposts%2F408863161021166&show_text=true&width=500" width="500" height="635" style="border:none;overflow:hidden; background-color: #fff" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>-->
<!--          </div>-->
<!--          <div class="column is-3">-->
<!--            <blockquote class="tiktok-embed" cite="https://www.tiktok.com/@kaczkoland/video/7041234071774661894" data-video-id="7041234071774661894" style="max-width: 325px;" > <section> <a target="_blank" title="@kaczkoland" href="https://www.tiktok.com/@kaczkoland">@kaczkoland</a> <a title="piesek" target="_blank" href="https://www.tiktok.com/tag/piesek">#piesek</a> <a title="trend" target="_blank" href="https://www.tiktok.com/tag/trend">#trend</a> <a title="minecraft" target="_blank" href="https://www.tiktok.com/tag/minecraft">#minecraft</a> <a target="_blank" title="♬ Bulsjarz Pieeeeeeesek - Jarz" href="https://www.tiktok.com/music/Bulsjarz-Pieeeeeeesek-7040151145687419653">♬ Bulsjarz Pieeeeeeesek - Jarz</a> </section> </blockquote>-->
<!--          </div>-->
<!--          <div class="column is-2">-->
<!--            <div style="height: 40vh; width: 100%; background-color: white; border-radius: 16px;">-->
<!--              <img src="/pieseek_1.3.1.jpg" style="border-radius: 16px 16px 0px 0px; height: 74%; width: 100%; object-fit: cover">-->
<!--              <div class="is-flex pt-1 pl-1 is-align-items-center">-->
<!--                <img src="/kaczucha.png" style="width: 30px; border-radius: 10px">-->
<!--                <h1 class="ml-1 has-text-weight-bold">rkubapl</h1>-->
<!--              </div>-->
<!--              <h1 class="has-text-weight-normal pl-1" style="font-size: 16px">Pingwin, który wpatrywał się w #anime</h1>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="column  is-4">-->
<!--            <twitter-card></twitter-card>-->
<!--          </div>-->
<!--          <div class="column is-2" style="height: 100%">-->
<!--            <div style="border-radius: 16px; background-color: #fff; height: 17vw; position: relative;">-->
<!--              <font-awesome-icon icon="fa-brands fa-tiktok" class="twitterIcon" style="color: #fff; position: absolute; top: 15px; right: 15px; font-size: 1.5rem"></font-awesome-icon>-->
<!--              <img src="/aaaa.jpg" style="border-radius: 16px; height: 100%; width: 100%; object-fit: cover">-->
<!--              <div style="display: flex; align-items: center; position: absolute; bottom: 10px; left: 10px; gap: 8px;">-->
<!--                <font-awesome-icon icon="fa-solid fa-eye" style="color: #fff; font-size: 1.25rem" />-->
<!--                <span class="has-text-weight-normal poppins" style="color: #fff; font-size: 1.25rem">500</span>-->
<!--              </div>-->
<!--              <div style="height: 20%; position: absolute; background-color: rgba(255, 255, 255, 0.7); bottom: 0; width: 100%; border-radius: 0 0 16px 16px; padding: 5px;">-->
<!--                  <span class="has-text-weight-normal poppins">Aplikacja "Jestem bogaty" za 999$ #ciekawostka</span>-->
<!--              </div>-->
<!--              safdsf-->
<!--            </div>-->
<!--          </div>-->
          <template v-for="item in data.cards">
            <div class="column is-4 gap-mobile" v-if="item.type === 'twitter'" :key="item">
              <twitter-card :id="item.data.id" :content="item.data.text" :like-count="item.data.info.likes" :retweet-count="item.data.info.retweets" :date="item.data.created_at" :comment-count="item.data.info.comments"></twitter-card>
            </div>
            <div class="column is-4 gap-mobile" :key="item" v-if="item.type === 'youtube'">
              <youtube-card :id="item.data.id" :title="item.data.title" :date="item.data.publishedAt" :thumbnail="item.data.thumbnail"></youtube-card>
            </div>
          </template>
          <!--          <Tiktok></Tiktok>-->
<!--          <Instagram avatar="https://cdn.discordapp.com/avatars/494017032283619329/d5b80d95530ee60fabddd4e69a9761de.png?size=4096" username="rkubapl" mention="@rkubapl" content="siema" image="kaczka.png"></Instagram>-->
<!--          <Twitter avatar="https://cdn.discordapp.com/avatars/494017032283619329/d5b80d95530ee60fabddd4e69a9761de.png?size=4096" username="rkubapl" mention="@rkubapl" content="siema"></Twitter>-->
<!--          <Facebook avatar="https://cdn.discordapp.com/avatars/494017032283619329/d5b80d95530ee60fabddd4e69a9761de.png?size=4096" username="rkubapl" :date="13213453" content="siema"></Facebook>-->
        </div>
        <div class="buttons-container">
          <a class="social-button" href="https://www.youtube.com/channel/UCdupJ-JLCWGcvPU2Ek3RprQ" target="_blank" rel="noopener">
            <font-awesome-icon icon="fa-brands fa-youtube" style="font-size: 1.2rem; color: #FF0000"></font-awesome-icon>
            <span>{{ $t("socialMedia.moreVideos") }}</span>
          </a>
          <a class="social-button" href="https://twitter.com/rkubapl" target="_blank" rel="noopener">
            <font-awesome-icon icon="fa-brands fa-twitter" style="font-size: 1.2rem; color: #1DA1F2"></font-awesome-icon>
            <span>{{ $t("socialMedia.moreTweets") }}</span>
          </a>
        </div>
<!--        <h1 class="title medium has-text-centered" style="color: white">{{ $t('socialMedia.stats') }}</h1>-->
<!--        <h1 class="subtitle has-text-weight-normal has-text-centered" style="color: white">Moim mniejszym hobby jest tworzenie filmów na Tiktoka oraz Youtube'a (głownie jako shortów)</h1>-->
<!--        <div class="columns is-centered">-->
<!--          <div class="column is-3 has-text-centered">-->
<!--            <h2 class="subtitle has-text-white is-4">Wyświetlenia</h2>-->
<!--            <h3 class="title is-3 has-text-white">{{ roundNumber(data.statistics.youtube.kaczkolandShorts.viewCount + data.statistics.youtube.kaczkoland.viewCount + data.statistics.youtube.rkubapl.viewCount + data.statistics.tiktok.kaczkoland.videoViews + data.statistics.tiktok.rkubapl.videoViews) }}</h3>-->
<!--          </div>-->
<!--          <div class="column is-3 has-text-centered">-->
<!--            <h2 class="subtitle has-text-white is-4">Obserwacje</h2>-->
<!--            <h3 class="title has-text-white is-3">450M</h3>-->
<!--          </div>-->
<!--          <div class="column is-3 has-text-centered">-->
<!--            <h2 class="subtitle has-text-white is-4">Filmy</h2>-->
<!--            <h3 class="title has-text-white is-3">450M</h3>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="columns">-->
<!--            <div class="column is-4">-->

<!--            </div>-->
<!--        </div>-->
<!--        <div style="background-color: #ff9b00; opacity: 0.7; border-radius: 16px;">-->
<!--          dsfdsfdsf-->
<!--        </div>-->
<!--        <div class="columns is-multiline is-centered">-->
<!--          <SocialMediaStats name="Kaczkoland Shorts" avatar="/logo-kaczkoland.png" :data="data.statistics.youtube.kaczkolandShorts" description="Krótkie ciekawostki o Minecraftcie" type="youtube"></SocialMediaStats>-->
<!--          <SocialMediaStats name="rkubapl" avatar="/kaczucha.png" :data="data.statistics.youtube.rkubapl" description="Mój personalny kanał na Youtube" type="youtube"></SocialMediaStats>-->
<!--          <SocialMediaStats name="Kaczkoland" avatar="/logo-kaczkoland.png" :data="data.statistics.youtube.kaczkoland" description="Kanał Youtube serwera Minecraft Kaczkoland.pl" type="youtube"></SocialMediaStats>-->
<!--          <SocialMediaStats name="Kaczkoland" avatar="/logo-kaczkoland.png" :data="data.statistics.tiktok.kaczkoland" description="Krótkie ciekawostki o Minecraftcie" type="tiktok"></SocialMediaStats>-->
<!--          <SocialMediaStats name="rkubapl" avatar="/kaczucha.png" :data="data.statistics.tiktok.rkubapl" description="Mój personalny profil na Tiktoku" type="tiktok"></SocialMediaStats>-->

          <!--          <div class="column is-4">-->
<!--            <div style="border-radius: 16px; background-color: #C4C4C4;" class="m-2 p-2">-->
<!--              <font-awesome-icon icon="fa-brands fa-youtube" style="font-size: 2rem; position: absolute" class="m-1"></font-awesome-icon>-->
<!--              <div class="is-flex is-align-items-center is-justify-content-center">-->
<!--                <img src="/logo-kaczkoland.png" style="border-radius: 15px; width: 48px">-->
<!--                <h1 class="title pl-2 has-text-weight-bold is-4">Kaczkoland Shorts</h1>-->
<!--              </div>-->
<!--              <h2 class="subtitle is-5 has-text-weight-normal has-text-centered mb-2">Mój personalny profil na Tiktoku</h2>-->
<!--              <div class="columns is-mobile is-gapless pb-2 mb-1">-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Wyświetlenia</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.youtube.kaczkolandShorts.viewCount) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Subskrybcje</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.youtube.kaczkolandShorts.subscriberCount) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Ilość filmów</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.youtube.kaczkolandShorts.videoCount) }}</h3>-->
<!--                </div>-->
<!--              </div>-->
<!--              <p class="subtitle has-text-centered has-text-weight-semibold is-6">Ostatnia aktualizacja: {{ dateToString(data.statistics.tiktok.kaczkoland.timestamp) }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="column is-4">-->
<!--            <div style="border-radius: 16px; background-color: #C4C4C4;" class="m-2 p-2">-->
<!--              <font-awesome-icon icon="fa-brands fa-youtube" style="font-size: 2rem; position: absolute" class="m-1"></font-awesome-icon>-->
<!--              <div class="is-flex is-align-items-center is-justify-content-center">-->
<!--                <img src="/kaczucha.png" style="border-radius: 15px; width: 48px">-->
<!--                <h1 class="title pl-2 has-text-weight-bold is-4">rkubapl</h1>-->
<!--              </div>-->
<!--              <h2 class="subtitle is-5 has-text-weight-normal has-text-centered mb-2">Mój personalny kanał na Youtube</h2>-->
<!--              <div class="columns is-mobile is-gapless pb-2 mb-1">-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Wyświetlenia</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.youtube.rkubapl.viewCount) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Subskrybcje</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.youtube.rkubapl.subscriberCount) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Ilość filmów</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.youtube.rkubapl.videoCount) }}</h3>-->
<!--                </div>-->
<!--              </div>-->
<!--              <p class="subtitle has-text-centered has-text-weight-semibold is-6">Ostatnia aktualizacja: {{ dateToString(data.statistics.youtube.rkubapl.timestamp) }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="column is-4">-->
<!--            <div style="border-radius: 16px; background-color: #C4C4C4;" class="m-2 p-2">-->
<!--              <font-awesome-icon icon="fa-brands fa-youtube" style="font-size: 2rem; position: absolute" class="m-1"></font-awesome-icon>-->
<!--              <div class="is-flex is-align-items-center is-justify-content-center">-->
<!--                <img src="/logo-kaczkoland.png" style="border-radius: 15px; width: 48px">-->
<!--                <h1 class="title pl-2 has-text-weight-bold is-4">Kaczkoland</h1>-->
<!--              </div>-->
<!--              <h2 class="subtitle is-5 has-text-weight-normal has-text-centered mb-2">Mój personalny profil na Tiktoku</h2>-->
<!--              <div class="columns is-mobile is-gapless pb-2 mb-1">-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Wyświetlenia</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.youtube.kaczkoland.viewCount) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Subskrybcje</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.youtube.kaczkoland.subscriberCount) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Ilość filmów</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.youtube.kaczkoland.videoCount) }}</h3>-->
<!--                </div>-->
<!--              </div>-->
<!--              <p class="subtitle has-text-centered has-text-weight-semibold is-6">Ostatnia aktualizacja: {{ dateToString(data.statistics.tiktok.rkubapl.timestamp) }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="column is-4">-->
<!--            <div style="border-radius: 16px; background-color: #C4C4C4;" class="m-2 p-2">-->
<!--              <font-awesome-icon icon="fa-brands fa-tiktok" style="font-size: 2rem; position: absolute" class="m-1"></font-awesome-icon>-->
<!--              <div class="is-flex is-align-items-center is-justify-content-center">-->
<!--                <img src="/kaczucha.png" style="border-radius: 15px; width: 48px">-->
<!--                <h1 class="title pl-2 has-text-weight-bold is-4">rkubapl</h1>-->
<!--              </div>-->
<!--              <h2 class="subtitle is-5 has-text-weight-normal has-text-centered mb-2">Mój personalny profil na Tiktoku</h2>-->
<!--              <div class="columns is-mobile is-gapless pb-2 mb-1">-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Wyświetlenia</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.tiktok.rkubapl.videoViews) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Obserwacje</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.tiktok.rkubapl.followers) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Ilość filmów</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.tiktok.rkubapl.videos) }}</h3>-->
<!--                </div>-->
<!--              </div>-->
<!--              <p class="subtitle has-text-centered has-text-weight-semibold is-6">Ostatnia aktualizacja: {{ dateToString(data.statistics.tiktok.rkubapl.timestamp) }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="column is-4">-->
<!--            <div style="border-radius: 16px; background-color: #C4C4C4;" class="m-2 p-2">-->
<!--              <font-awesome-icon icon="fa-brands fa-tiktok" style="font-size: 2rem; position: absolute" class="m-1"></font-awesome-icon>-->
<!--              <div class="is-flex is-align-items-center is-justify-content-center">-->
<!--                <img src="/logo-kaczkoland.png" style="border-radius: 15px; width: 48px">-->
<!--                <h1 class="title pl-2 has-text-weight-bold is-4">Kaczkoland</h1>-->
<!--              </div>-->
<!--              <h2 class="subtitle is-5 has-text-weight-normal has-text-centered mb-2">Mój personalny profil na Tiktoku</h2>-->
<!--              <div class="columns is-mobile is-gapless pb-2 mb-1">-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Wyświetlenia</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.tiktok.kaczkoland.videoViews) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Obserwacje</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.tiktok.kaczkoland.followers) }}</h3>-->
<!--                </div>-->
<!--                <div class="column is-4 has-text-centered">-->
<!--                  <h2 class="title has-text-weight-medium is-5 mb-4">Ilość filmów</h2>-->
<!--                  <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">{{ roundNumber(data.statistics.tiktok.kaczkoland.videos) }}</h3>-->
<!--                </div>-->
<!--              </div>-->
<!--              <p class="subtitle has-text-centered has-text-weight-semibold is-6">Ostatnia aktualizacja: {{ dateToString(data.statistics.tiktok.rkubapl.timestamp) }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--          <div class="column is-6">-->
<!--            <div style="border-radius: 16px; background-color: #C4C4C4;" class="p-2 m-2">-->
<!--              <div class="is-flex is-align-items-center is-justify-content-center">-->
<!--                  <img src="/kaczucha.png" style="border-radius: 15px; width: 48px">-->
<!--                  <h1 class="title pl-2 has-text-weight-bold is-4">rkubapl</h1>-->
<!--              </div>-->
<!--              <h2 class="subtitle is-4 has-text-weight-normal has-text-centered mb-2">Mój personalny kanał na Youtube</h2>-->
<!--              <div class="columns is-multiline">-->
<!--                <div class="column is-6 has-text-centered">-->
<!--                  <div class="is-flex is-align-items-center is-justify-content-center" style="gap: 6px">-->
<!--                    <font-awesome-icon icon="fa-brands fa-youtube" style="font-size: 1.75rem;"></font-awesome-icon>-->
<!--                    <h1 class="title has-text-weight-medium is-3">Youtube</h1>-->
<!--                  </div>-->
<!--                  <div class="columns">-->
<!--                    <div class="column is-4">-->
<!--                      <h2 class="title has-text-weight-medium is-5 mb-4">Wyświetlenia</h2>-->
<!--                      <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">15K</h3>-->
<!--                    </div>-->
<!--                    <div class="column is-4">-->
<!--                      <h2 class="title has-text-weight-medium is-5 mb-4">Subskrybcje</h2>-->
<!--                      <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">82</h3>-->
<!--                    </div>-->
<!--                    <div class="column is-4">-->
<!--                      <h2 class="title has-text-weight-medium is-5 mb-4">Ilość filmów</h2>-->
<!--                      <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">250</h3>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="column is-half has-text-centered">-->
<!--                  <div class="is-flex is-align-items-center is-justify-content-center" style="gap: 6px">-->
<!--                    <font-awesome-icon icon="fa-brands fa-tiktok" style="font-size: 1.75rem;"></font-awesome-icon>-->
<!--                    <h1 class="title has-text-weight-medium is-3">Tiktok</h1>-->
<!--                  </div>-->
<!--                  <div class="columns is-mobile">-->
<!--                    <div class="column is-4">-->
<!--                      <h2 class="title has-text-weight-medium is-5 mb-4">Wyświetlenia</h2>-->
<!--                      <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">120K</h3>-->
<!--                    </div>-->
<!--                    <div class="column is-4">-->
<!--                      <h2 class="title has-text-weight-medium is-5 mb-4">Obserwacje</h2>-->
<!--                      <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">250</h3>-->
<!--                    </div>-->
<!--                    <div class="column is-4">-->
<!--                      <h2 class="title has-text-weight-medium is-5 mb-4">Ilość filmów</h2>-->
<!--                      <h3 class="subtitle has-text-weight-medium is-4" style="color: #ff0000">250</h3>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 290" style="line-height: 0; "><path fill="#639fff" fill-opacity="1" d="M0,256L48,224C96,192,192,128,288,96C384,64,480,64,576,80C672,96,768,128,864,170.7C960,213,1056,267,1152,266.7C1248,267,1344,213,1392,186.7L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path></svg>
    </div>
    <section class="section" id="contact" style="padding-top: 0" data-aos="zoom-in-up">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column is-5">
            <h2 class="title is-2 bold contact-text">{{ $t('contact.title') }}</h2>
            <h3 class="subtitle is-4 bold contact-text has-text-weight-normal mb-3">
              {{ $t('contact.subtitle') }}
            </h3>
            <div class="contactTextIcon">
              <font-awesome-icon icon="fa-brands fa-discord" style="color: #639fff; font-size: 3rem; width: 50px"></font-awesome-icon>
              <div>
                <h3 class="title is-4 mb-0">Discord</h3>
                <span class="subtitle is-5 mt-0">rkubapl#0556</span>
              </div>
            </div>
            <div class="contactTextIcon">
              <font-awesome-icon icon="fa-solid fa-envelope" style="color: #639fff; font-size: 3rem;  width: 50px"></font-awesome-icon>
              <div>
                <h3 class="title is-4 mb-0">E-mail</h3>
                <a class="subtitle is-5 mt-0" style="color: #639fff" href="mailto:kontakt@rkuba.pl">kontakt@rkuba.pl</a>
              </div>
            </div>
            <div class="contactIconContainer">
              <a class="sm-icon" href="https://messenger.com/t/rkubapl" target="_blank" rel="noopener">
                <font-awesome-icon icon="fa-brands fa-facebook-messenger"></font-awesome-icon>
              </a>
              <a class="sm-icon" href="https://twitter.com/rkubapl" target="_blank" rel="noopener">
                <font-awesome-icon icon="fa-brands fa-twitter"></font-awesome-icon>
              </a>
              <a class="sm-icon" href="https://messenger.com/rkubapl" target="_blank" rel="noopener">
                <font-awesome-icon icon="fa-brands fa-instagram"></font-awesome-icon>
              </a>
            </div>

<!--            <div class="columns">-->
<!--              <div class="column is-4">-->
<!--                <h2 class="title medium has-text-centered">{{ $t('contact.mail') }}</h2>-->
<!--                <h3 class="subtitle regular has-text-centered">kontakt@rkuba.pl</h3>-->
<!--              </div>-->
<!--              <div class="column is-4">-->
<!--                <h2 class="title medium has-text-centered">{{ $t('contact.discord') }}</h2>-->
<!--                <h3 class="subtitle regular has-text-centered">rkubapl#0556</h3>-->
<!--              </div>-->
<!--              <div class="column is-4">-->
<!--                <h2 class="title medium has-text-centered">{{ $t('contact.messenger') }}</h2>-->
<!--                <h3 class="subtitle regular has-text-centered"><a class="https://m.me/rkubapl" target="_blank">m.me/rkubapl</a></h3>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="column is-6 is-offset-1">
            <div style="background-color: #e7e7e7; padding: 10px; border-radius: 16px; position: relative" @click="(cookie === false ? cookieBox = true : '')">
              <div :class="[{contactCookie: true}, {active: cookieBox}]">
                <div style="text-align: center; padding: 16px;">
                  <h3 class="title is-3 has-text-weight-semibold">{{ $t("form.cookie.title") }}</h3>
                  <h3 class="subtitle is-5 has-text-weight-normal">{{ $t("form.cookie.subtitle") }} <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">policies.google.com/privacy</a></h3>
                  <a class="button is-success" @click="acceptCookie">{{ $t("form.cookie.accept") }}</a>
                </div>
              </div>
              <div v-if="!sentForm" :class="{blockIndex: cookieBox}">
                <h3 class="title is-3 semibold has-text-centered mb-0">{{ $t('form.title') }}</h3>

                <ValidationObserver v-slot="{ handleSubmit }">
                  <form @submit.prevent="handleSubmit(sendForm)">
                    <InputValidation
                        rules="required|min:4"
                        name="name"
                        vid="name"
                        :label="$t('form.name')"
                        v-model="formData.name"
                    ></InputValidation>

                    <InputValidation
                        rules="required|email"
                        name="mail"
                        vid="mail"
                        :label="$t('form.email')"
                        v-model="formData.email"
                    ></InputValidation>

                    <InputValidation
                        rules="required|min:50"
                        name="message"
                        vid="message"
                        :label="$t('form.message')"
                        type="textarea"
                        v-model="formData.message"
                    ></InputValidation>

                    <vue-recaptcha sitekey="6LfLk9UeAAAAAL0pfi0MbK4O06iyORVhZMVKTHGD" @verify="verifyMethod" @expired="expiriedMethod" v-if="cookie"></vue-recaptcha>
                    <p class="has-text-danger has-text-weight-semibold" v-for="error in errors.other" :key="error">{{ error }}</p>

                    <div style="text-align: center;" class="mt-2">
                      <button class="contact-button" type="submit">
                        <font-awesome-icon icon="fa-solid fa-paper-plane" style="font-size: 1.2rem;"></font-awesome-icon>
                        <span>{{ $t("form.send") }}</span>
                      </button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
              <div v-else>
                <div class="has-text-centered mt-6 mb-6">
                  <h3 class="title is-3 has-text-weight-bold">{{ $t("form.confirm.title") }}</h3>
                  <h3 class="subtitle is-4 has-text-weight-normal">{{ $t("form.confirm.subtitle") }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer style="background: #f1f1f2;">
      <div class="container has-text-centered" style="padding-bottom: 75px; padding-top: 50px">
        <h3 class="title semibold is-4 mb-2">Strona <font-awesome-icon icon="fa-solid fa-code"></font-awesome-icon> przez rkubapl</h3>
        <div style="display: flex; align-items: center; justify-content: center; gap: 15px;">
          <a href="https://twitter.com/rkubapl" target="_blank" rel="noopener"><font-awesome-icon icon="fa-brands fa-twitter" class="iconFooter"></font-awesome-icon></a>
          <a href="https://youtube.com/channel/UCdupJ-JLCWGcvPU2Ek3RprQ" target="_blank" rel="noopener"><font-awesome-icon icon="fa-brands fa-youtube" class="iconFooter"></font-awesome-icon></a>
          <a href="https://instagram.com/rkubapl" target="_blank" rel="noopener"><font-awesome-icon icon="fa-brands fa-instagram" class="iconFooter"></font-awesome-icon></a>
          <a href="https://tiktok.com/@rkubapl" target="_blank" rel="noopener"><font-awesome-icon icon="fa-brands fa-tiktok" class="iconFooter"></font-awesome-icon></a>
          <a href="https://discord.rkuba.pl" target="_blank" rel="noopener"><font-awesome-icon icon="fa-brands fa-discord" class="iconFooter"></font-awesome-icon></a>
        </div>
<!--        <hr style="border: #444242 solid 1px;">-->
        <br>
        <h3 class="subtitle regular is-6 mb-1">{{ $t("footer.credits") }} <a href="https://buefy.org/" target="_blank" rel="noopener">Buefy</a>, <a href="https://fonts.google.com/specimen/Poppins" target="_blank" rel="noopener">Poppins</a>, <a href="https://fonts.google.com/specimen/Roboto" target="_blank" rel="noopener">Roboto</a>, <a href="https://fontawesome.com/" target="_blank" rel="noopener">FontAwesome</a>, <a href="https://vuejs.org/" target="_blank" rel="noopener">Vue, vue-cli, vue-router</a>, <a href="https://vee-validate.logaretm.com/" target="_blank" rel="noopener">vee-validate</a>, <a href="https://kazupon.github.io/vue-i18n/" target="_blank" rel="noopener">vue-i18n</a>, <a href="https://flagpedia.net/" target="_blank">flagpedia.net</a>, <a href="https://unsplash.com/photos/KWBBCjJHKVc" target="_blank">background</a>, <a href="https://michalsnik.github.io/aos/" target="_blank">AOS</a>, <a href="https://about.twitter.com/en/who-we-are/brand-toolkit" target="_blank" rel="noopener">Twitter icons</a></h3>
        <a @click="declineCookie" v-if="cookie">{{ $t('footer.declineCookie') }}</a>
      </div>
    </footer>
  </div>
</template>


<script>
import Header from "@/components/Header";

import {VueRecaptcha} from 'vue-recaptcha';

// import Twitter from "@/components/social-media/Twitter";
// import Instagram from "@/components/social-media/Instagram";
// import Youtube from "@/components/social-media/Youtube";
// import SocialMediaStats from "@/components/social-media/SocialMediaStats";
import axios from "axios";
import {dateToString} from "@/date";
import TwitterCard from "@/components/social-media/TwitterCard";
import YoutubeCard from "@/components/social-media/YoutubeCard";
import InputValidation from "@/components/social-media/InputValidation";
import {ValidationObserver} from "vee-validate";
// import Facebook from "@/components/social-media/Facebook";
// import Tiktok from "@/components/social-media/Tiktok";
// import { ValidationProvider } from 'vee-validate';

export default {
  name: 'Home',
  components: {
    YoutubeCard,
    TwitterCard, Header,
    VueRecaptcha,
    InputValidation,
    ValidationObserver
    // SocialMediaStats
  },
  data() {
    return {
      data: [],
      responseRecaptcha: undefined,
      formData: {
        name: undefined,
        email: undefined,
        message: undefined
      }, errors: {
        name: undefined,
        email: undefined,
        message: undefined,
        other: []
      },
      sentForm: false,
      cookie: false,
      cookieBox: false
    }
  },
  async created() {
    const response = await axios.get("https://api.rkuba.pl/data");

    this.data = response.data;

    const locales = ["pl", "gb"];

    const ipstack = await axios.get("https://cloudflare-quic.com/b/headers");

    const lang = ipstack.data.headers['Cf-Ipcountry'];

    if(locales.includes(lang.toLowerCase())) {
      console.log(lang)
      this.$i18n.locale = lang.toLowerCase();
    }


    if(this.getCookie("captcha") === "allow") {
      this.cookie = true;
    }
  }, methods: {
    roundNumber(labelValue) {
      return this.twoDecimalPlaces(Math.abs(Number(labelValue)) >= 1.0e+9)
          ? this.twoDecimalPlaces(Math.abs(Number(labelValue)) / 1.0e+9) + "B"
          // Six Zeroes for Millions
          : this.twoDecimalPlaces(Math.abs(Number(labelValue)) >= 1.0e+6)
              ? this.twoDecimalPlaces(Math.abs(Number(labelValue)) / 1.0e+6) + "M"
              // Three Zeroes for Thousands
              : this.twoDecimalPlaces(Math.abs(Number(labelValue)) >= 1.0e+3)
                  ? this.twoDecimalPlaces(Math.abs(Number(labelValue)) / 1.0e+3) + "K"
                  : this.twoDecimalPlaces(Math.abs(Number(labelValue)))
    }, twoDecimalPlaces(num) {
      console.log(num)
      return Math.round((num + Number.EPSILON) * 100) / 100
    }, dateToString,
    open(url) { window.open(url) },
    verifyMethod(response) { this.responseRecaptcha = response; },
    expiriedMethod() { this.responseRecaptcha = undefined; },
    async sendForm() {
      if(!this.cookie) return;

      this.errors.other = [];

      if(!this.responseRecaptcha) {
        this.errors.other.push(this.$t("error.captchaRequired"));
        return;
      }

      axios.post("https://api.rkuba.pl/contact", JSON.stringify({name: this.formData.name, email: this.formData.email, message: this.formData.message, captcha: this.responseRecaptcha}))
      .then(response => {
        if(response.data.success) {
          this.sentForm = true;
        } else {
          this.errors.other.push(this.$t("form.failed"))
        }
      }).catch(() => {
        this.errors.other.push(this.$t("form.failed"))
      });
    }, getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }, setCookie(name,value,days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }, acceptCookie() {
      this.setCookie("captcha", "allow", 365);
      this.cookie = true;

      this.cookieBox = false;
    }, deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }, declineCookie() {
      this.deleteCookie("captcha");
      this.$router.go(this.$router.currentRoute);
    }
  }
  // components: {Header}
}
</script>
